import React, { useState, useEffect, useCallback, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import EquipDetailHeader from "../ReusableComponent/equipDetailHeader";
import TabsActions from "../../Actions/TabsActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import FileUploadDragDrop from "../ReusableComponent/FileUploadDragDrop";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";
import commonUtils from "../../helpers/commonUtils";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import ConfirmBox from "../MessageBox/ConfirmBox";

export default function DocumentListView(props) {
  const { anlageid, tabid, handleTourGuid } = props;
  const [showFileUploadDialog, setShowFileUploadDialog] = useState(false);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [confirmBoxOpen, setConfirmBoxOpen] = useState(false);
  const [confirmBoxMsg, setConfirmBoxMsg] = useState(null);
  const [data, setData] = useState(null);
  const abnahme = useRef(false);
  const [betrbutton, setBetrbutton] = useState(null);

  const closeMsg = () => {
    setConfirmBoxOpen(false);
  };

  useEffect(() => {
    setGlobalSpinner(true);

    if (anlageid !== null && anlageid !== undefined) {
      TabsActions.getDocuments(anlageid);
    }

    return () => {};
  }, [anlageid]);

  useEffect(() => {
    if (Number(sessionStorage.getItem("eqGId")) === 1) {
      let tmp = null;
      tmp = (
        <div className="form-group" style={{ marginRight: "15px" }}>
          <label
            className="btn btn-primary"
            onClick={() => {
              setConfirmBoxOpen(true);
            }}
          >
            {localization.generateOperatingInstructions}{" "}
          </label>
        </div>
      );
      setBetrbutton(tmp);
    }
  }, []);

  useEffect(() => {
    let para = null;
    para = (
      <p>
        {localization.documentMsg_1}{" "}
        <strong>{localization.documentmsg_2}</strong>{" "}
        {localization.documentmsg_3}
      </p>
    );
    setConfirmBoxMsg(para);
  }, []);

  useEffect(() => {
    function updateData() {
      var _details = tabsStore.getResult();
      //   if (isMountedRef.current) {
      //     setData(_details);
      //   }
      setData(_details);
      handleTourGuid(4);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTS_SUCCESS,
      updateData
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTS_SUCCESS,
        updateData
      );
    };
  }, []);

  const betrGenerate = (mitAbnahmeprotokoll) => {
    closeMsg();
    setGlobalSpinner(true);
    if (mitAbnahmeprotokoll) {
      TabsActions.getAcceptanceProtocol(anlageid, mitAbnahmeprotokoll);
    } else {
      TabsActions.betriebsanleitungGenerieren(anlageid, mitAbnahmeprotokoll);
    }
    abnahme.current = mitAbnahmeprotokoll;

    // setAbnahme(mitAbnahmeprotokoll);
  };

  useEffect(() => {
    function updateDataSuccess() {
      setGlobalSpinner(false);
      TabsActions.getDocuments(anlageid);
    }

    function updateDataFailure() {
      const res = tabsStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS,
      updateDataSuccess
    );
    tabsStore.addChangeListener(
      tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_FAILURE,
      updateDataFailure
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS,
        updateDataSuccess
      );
      tabsStore.removeChangeListener(
        tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_FAILURE,
        updateDataFailure
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setGlobalSpinner(false);
      TabsActions.getDocuments(anlageid);
      toast.success(localization.addBetrSuccess);
      // if (abnahme.current) {
      //   // wenn mit abnahmeprotokoll, dann dieses rausgeben (auf den pfad wird es durch webservice abgelegt). ferner sollte der pfad aus der db kommen
      //   var anlageid = Number(sessionStorage.getItem("eqId"));
      //   tabsActions.getDocumentAsByte(
      //     "\\\\emea.corpdir.net\\egag_proj\\Projekte\\EGAG\\_AppData\\Access_DB\\PruefExpress\\Abnahmeprotokoll_temp\\Abnahmeprotokoll.pdf",
      //     "Abnahmeprotokoll.pdf",
      //     anlageid
      //   );
      //   abnahme.current = false;
      // }
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_BETR_SUCCESS,
      updateData
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_BETR_SUCCESS,
        updateData
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setGlobalSpinner(false);
      toast.error(localization.addBetrError);
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_BETR_FAILURE,
      updateData
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_BETR_FAILURE,
        updateData
      );
    };
  }, []);

  const handleShow = (item) => {
    setGlobalSpinner(true);
    TabsActions.getDocumentAsByte(item.id, item.bezeichnung);
  };

  useEffect(() => {
    function downloadDocumentSuccess() {
      var _details = tabsStore.getResult();
      setGlobalSpinner(false);
    }

    function downloadDocumentFailure() {
      var res = tabsStore.getResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
      downloadDocumentSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
      downloadDocumentFailure
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
        downloadDocumentSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
        downloadDocumentFailure
      );
    };
  }, []);

  const handleUpload = (fileData) => {
    setGlobalSpinner(true);
    if (fileData.filetoStringarray.length > 0) {
      let obj = {
        anlageid: anlageid,
        // DocumentType: filetypeId,
        files: fileData.filetoStringarray,
      };
      TabsActions.addDocument(obj);
    } else {
      setGlobalSpinner(false);
    }
  };

  useEffect(() => {
    function updateDocumentSuccess() {
      toast.success(localization.documentSaveSuccess);
      setShowFileUploadDialog(false);
      TabsActions.getDocuments(anlageid);
    }

    function updateDocumentError() {
      toast.error(localization.documentSaveError);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.ADD_DOCUMENT_SUCCESS,
      updateDocumentSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.ADD_DOCUMENT_FAILURE,
      updateDocumentError
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.ADD_DOCUMENT_SUCCESS,
        updateDocumentSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.ADD_DOCUMENT_FAILURE,
        updateDocumentError
      );
    };
  }, []);

  const handelDelete = (item) => {
    if (window.confirm(localization.deleteConfir)) {
      setGlobalSpinner(true);
      TabsActions.deleteDocument(item.id);
    }
  };

  useEffect(() => {
    function deleteDocumentSuccess() {
      toast.success(localization.documentDeleteSuccess);
      TabsActions.getDocuments(anlageid);
    }

    function deleteDocumentError() {
      const res = tabsStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.DELETE_DOCUMENT_SUCCESS,
      deleteDocumentSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.DELETE_DOCUMENT_FAILURE,
      deleteDocumentError
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.DELETE_DOCUMENT_SUCCESS,
        deleteDocumentSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.DELETE_DOCUMENT_FAILURE,
        deleteDocumentError
      );
    };
  }, []);

  function BasicTable() {
    return (
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className="simpleListTable"
        >
          <TableHead>
            <TableRow>
              <TableCell>{localization.name}</TableCell>
              <TableCell align="left">{localization.date}</TableCell>
              <TableCell align="center">{localization.actions}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.map((row, index) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left">
                    <InsertDriveFileOutlinedIcon className="documentIcon" />
                    {row.bezeichnung}
                  </TableCell>
                  <TableCell align="left">{row.eintragDatum}</TableCell>
                  <TableCell align="center">
                    <button
                      className="actionBtnCls mr-5"
                      onClick={() => {
                        handleShow(row);
                      }}
                    >
                      {localization.download}
                    </button>
                    {!commonUtils.isReader() && (
                      <button
                        className="actionBtnCls"
                        onClick={() => {
                          handelDelete(row);
                        }}
                      >
                        {localization.delete}
                      </button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  const uploadBtnCallBack = () => {
    setShowFileUploadDialog(true);
  };

  const hideUploadButtonFlag =
    commonUtils.isReader() || sessionStorage.getItem("isReaderOnly") === "true";

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <EquipDetailHeader
            title={localization.filesAndDocuments}
            description={localization.allFilesOfEquipment}
            buttonTitle={localization.hochladenbtb}
            onClickHandler={uploadBtnCallBack}
            hideButtonFlag={hideUploadButtonFlag}
          />
          {betrbutton && (
            <div className="col searchbtn-container">{betrbutton}</div>
          )}

          <div className="w-100 pt-5">
            {data && data.length > 0 ? (
              <BasicTable />
            ) : (
              <div className="text-center">{localization.noDocuments}</div>
            )}
          </div>
        </div>
      </div>
      {showFileUploadDialog && (
        <FileUploadDragDrop
          isOpen={showFileUploadDialog}
          setShowFileUploadDialog={setShowFileUploadDialog}
          title={localization.uploadNewFile}
          description={localization.uploadNewFileDesc}
          dragAndDropTitle={localization.dragAndDropFilesHere}
          browseButtonTitle={localization.browseFiles}
          type="Files"
          uploadHandler={handleUpload}
        />
      )}
      {confirmBoxOpen && (
        <ConfirmBox
          isOpen={confirmBoxOpen}
          func={betrGenerate}
          close={closeMsg}
          title={localization.documentTitle}
          msg={confirmBoxMsg}
        />
      )}
    </>
  );
}
